import * as React from "react";
import {Breadcrumb, Button, Table} from 'semantic-ui-react';

import localCss from "./PrintableTableStyle";

import i18n from "../../../../locale/i18n";
import ExportContextHolder from "../../../../lib/ExportContextHolder";
const translator = i18n.t.bind(i18n);

interface PrintableTableProps {
    reset: Function;
}

interface PrintableTableState {
    data: any;
    current?: number;
    total?: number;
    finishedRender: boolean;
}

const sleep = function(delay: number) {
    return new Promise((resolve) => {
        setTimeout(() => resolve(), delay);
    });
};

class PrintableTable extends React.Component<PrintableTableProps, PrintableTableState> {
    tbodyRef: React.RefObject<HTMLTableSectionElement> = React.createRef();

    constructor(props: PrintableTableProps) {
        super(props);

        this.state = {
            data: null,
            finishedRender: false
        }
    }

    componentDidMount() {

        if (ExportContextHolder.customContentToRender != null)
            return;

        ExportContextHolder.exportPrintV2(
            data => {
                this.setState({
                    data: [data[0]]
                }, async() => {
                    await this.customRenderer(data);
                });
            },
            (current, total) => {
                this.setState({
                    current: current,
                    total: total
                })
            },
            (error) => {
                // TODO error handling
                console.error(error);
            }
        );
    }

    async customRenderer(data: any[]) {
        // remove header row
        data.splice(0,1);

        const CHUNK_SIZE = 2000;
        const renderChunk = async () => {
            const chunk = data.splice(0, CHUNK_SIZE);
            console.log(`Rendering ${chunk.length} rows`);
            const trows: HTMLElement[] = [];
            for(let row of chunk) {
                const tr = document.createElement("tr");
                for(let cell of row) {
                    const td = document.createElement("td");
                    td.innerText = cell;
                    tr.appendChild(td);
                }
                trows.push(tr);
            }
            if(this.tbodyRef.current) {
                if(typeof this.tbodyRef.current.append === "function") {
                    this.tbodyRef.current.append(...trows);
                } else {
                    // IE Support
                    // even .appendChild does not work correctly from this context to popout, so set innerHTML directly
                    // TODO test this (especially as it is an popout) in different browsers
                    for(let trow of trows) {
                        this.tbodyRef.current.innerHTML += trow.outerHTML;
                    }
                }
            }
        };
        while(data.length > 0) {
            await renderChunk();
            await sleep(10); // not sure if async function without awaits in it is compiled to callbacks with timeout / requestAnimationFrame / ... => force pause execution with simple sleep timeout
        }
        this.setState({
            finishedRender: true
        })
    }

    componentWillUnmount() {
        this.props.reset();
    }

    render() {
        if (ExportContextHolder.customContentToRender != null)
            return <>
                    <style>
                        {localCss}
                    </style>

                    <Button className={"menu-button print-table__print-button"}
                            onClick={(event)=>{
                                try {
                                    if(event.currentTarget.ownerDocument && event.currentTarget.ownerDocument.defaultView) {
                                        let window = event.currentTarget.ownerDocument.defaultView;
                                        window.print();
                                        this.props.reset();
                                    }
                                } catch {}
                            }}
                    >{translator("Common.Print")}</Button>
                <br/>
                    {ExportContextHolder.customContentToRender}
                </>;

        let tableHeaderCells = (<></>);
        let columnCount = 0;

        if (this.state.data !== null) {
            tableHeaderCells = this.state.data[0].map((value: string, idx: number) => {
                return (<Table.HeaderCell key={'header_' + idx} singleLine>{value}</Table.HeaderCell>);
            });
            columnCount = this.state.data[0] && Array.isArray(this.state.data[0]) ? this.state.data[0].length : 0;
        }

        let breadcrumbSections: any[] = [];

        if(ExportContextHolder.routeData !== null) {
            ExportContextHolder.routeData.forEach((value, index) => {
                breadcrumbSections.push(
                    {content: value, link: true, key: 'bc_' + index}
                );
            });
        }

        return (this.state.data === null) ?
            (<>
                <b>{translator("Common.Loading")}</b>
                    {typeof this.state.current !== 'undefined' && (<p>{this.state.current} / {this.state.total}</p>)}
                </>
                ) // TODO add progress bar instead of simple text?
            :
            (<>
                {columnCount > 10 && <style>{`@media print{@page {size: landscape}}`}</style>} {/* set page orientation for print to landscape when more than 10 columns */}
                <style>
                    {localCss}
                </style>

                <Button disabled={!this.state.finishedRender} className={"menu-button print-table__print-button"}
                        onClick={(event)=>{
                            try {
                                if(event.currentTarget.ownerDocument && event.currentTarget.ownerDocument.defaultView) {
                                    let window = event.currentTarget.ownerDocument.defaultView;
                                    window.print();
                                    this.props.reset();
                                }
                            } catch {}
                        }}
                >{translator("Common.Print")}</Button>

                <h3>
                    <Breadcrumb icon="right angle" sections={breadcrumbSections} />
                </h3>


                    <Table celled compact singleLine unstackable>
                        <Table.Header>
                            <Table.Row>
                                {tableHeaderCells}
                            </Table.Row>
                        </Table.Header>
                        <tbody ref={this.tbodyRef}>
                            {ExportContextHolder.rowsToRender || <></>}
                        </tbody>

                    </Table>
            </>);
    }
}

export default PrintableTable;